import { HQ_STATUS, SERVICE_CATEGORIES } from '../config/ieumConfig';

export const ADMIN_REQUEST_FILTER_ALL = 'all';
export const ADMIN_REQUEST_FILTER_UNASSIGNED = 'unassigned';

const DEFAULT_EXCLUDED_STATUSES = new Set(['cancelled', 'unmatched_cancelled']);
const UNASSIGNED_STATUSES = new Set(['unread', 'read']);

const normalizeStatus = (value) => {
  if (value === ADMIN_REQUEST_FILTER_UNASSIGNED || HQ_STATUS[value]) return value;
  return ADMIN_REQUEST_FILTER_ALL;
};

const normalizeCategory = (value) => (
  SERVICE_CATEGORIES[value] ? value : ADMIN_REQUEST_FILTER_ALL
);

export const readAdminRequestFilters = (searchParams) => ({
  status: normalizeStatus(searchParams?.get('status')),
  category: normalizeCategory(searchParams?.get('category')),
  partner: searchParams?.get('partner') || ADMIN_REQUEST_FILTER_ALL,
});

export const requestMatchesAdminStatus = (request, rawStatus) => {
  const status = normalizeStatus(rawStatus);
  const requestStatus = request?.hqStatus || '';

  if (status === ADMIN_REQUEST_FILTER_ALL) {
    return !DEFAULT_EXCLUDED_STATUSES.has(requestStatus);
  }
  if (status === ADMIN_REQUEST_FILTER_UNASSIGNED) {
    return UNASSIGNED_STATUSES.has(requestStatus);
  }
  return requestStatus === status;
};

export const requestMatchesAdminCategory = (request, rawCategory) => {
  const category = normalizeCategory(rawCategory);
  if (category === ADMIN_REQUEST_FILTER_ALL) return true;

  const services = Array.isArray(request?.services) ? request.services : [];
  return request?.category === category || services.includes(category);
};

export const buildAdminRequestListUrl = ({
  status = ADMIN_REQUEST_FILTER_ALL,
  category = ADMIN_REQUEST_FILTER_ALL,
  partner = ADMIN_REQUEST_FILTER_ALL,
} = {}) => {
  const params = new URLSearchParams();
  const normalizedStatus = normalizeStatus(status);
  const normalizedCategory = normalizeCategory(category);

  if (normalizedStatus !== ADMIN_REQUEST_FILTER_ALL) params.set('status', normalizedStatus);
  if (normalizedCategory !== ADMIN_REQUEST_FILTER_ALL) params.set('category', normalizedCategory);
  if (partner && partner !== ADMIN_REQUEST_FILTER_ALL) params.set('partner', partner);

  const query = params.toString();
  return `/admin/service/requests${query ? `?${query}` : ''}`;
};

export const updateAdminRequestFilterParams = (searchParams, key, value) => {
  const next = new URLSearchParams(searchParams);
  if (!value || value === ADMIN_REQUEST_FILTER_ALL) next.delete(key);
  else next.set(key, value);
  return next;
};
